import { API } from '@Providers';

/**
 * NOTE
 * Removes the cart donation(s). We only process a single donation per cart at the moment,
 * so this clears the donation without requiring a payload. If multiple donations per cart
 * are supported later, the API could accept an optional donation _id to remove a specific one.
 */
export default async function RemoveCartDonationService() {
  const endpoint = '/api/shelter/cart/donation';

  return API({ endpoint, method: 'delete' });
}
